// extracted by mini-css-extract-plugin
export default {"signatureWrapper":"Signature_signatureWrapper__1DhqK","text":"Signature_text__AgrTo"};